import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { change, submit as submitForm } from 'redux-form';

import Guests from '../SearchListing/Filters/Guests/Guests';
import Dates from '../SearchListing/Filters/Dates/Dates';

import messages from '../../locale/messages';
import { closeSimplifiedFiltersModal } from '../../actions/modalActions';
import { setPersonalizedValues } from "../../actions/personalized";
import history from '../../core/history';

import bt from '../commonStyle.css';
import s from './SimplifiedFiltersModal.css';

class SimplifiedFiltersModal extends Component {
    static propTypes = {
        filtersModal: PropTypes.bool,
        closeSimplifiedFiltersModal: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            tabs: {
                dates: false,
                guests: false,
            },
        };
    }

    handleTabToggle = (currentTab, isExpand) => {
        const { tabs } = this.state;

        for (let key in tabs) {
            if (key == currentTab) {
                tabs[key] = isExpand;
            } else {
                tabs[key] = false;
            }
        }

        this.setState({ tabs });
    };

    handleCancel = () => {
        const { closeSimplifiedFiltersModal } = this.props;
        // Just close the modal without executing search
        closeSimplifiedFiltersModal();
    };

    handleApply = async () => {
        const { closeSimplifiedFiltersModal, personalized } = this.props;

        // Build search URL with filters
        let uri = '/s?';
        if (personalized?.location) {
            uri += '&address=' + personalized.location;
        }
        if (personalized?.chosen) {
            uri += '&chosen=' + personalized.chosen;
        }
        if (personalized?.startDate && personalized?.endDate) {
            uri += '&startdate=' + personalized.startDate + '&enddate=' + personalized.endDate;
        }
        if (personalized?.personCapacity) {
            uri += '&guests=' + personalized.personCapacity;
        }

        closeSimplifiedFiltersModal();

        // Navigate to search page with filters
        const updatedURI = encodeURI(uri);
        history.push(updatedURI);
    };

    render() {
        const { smallDevice, filtersModal } = this.props;
        const { tabs } = this.state;

        return (
            <div>
                <Modal
                    show={filtersModal}
                    animation={false}
                    onHide={this.handleCancel}
                    dialogClassName={cx(s.filterModalContainer, 'simplifiedFilterModal')}
                    backdrop="static"
                >
                    <Modal.Header closeButton className={s.panelHeader}>
                        <Modal.Title>
                            <span><FormattedMessage {...messages.filters} /></span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body bsClass={s.modalBody}>
                        <div className={s.filterContainer}>
                            <div className={s.filterSection}>
                                <Dates
                                    handleTabToggle={this.handleTabToggle}
                                    isExpand={tabs?.dates}
                                    smallDevice={smallDevice}
                                />
                            </div>
                            <div className={s.filterSection}>
                                <Guests
                                    handleTabToggle={this.handleTabToggle}
                                    isExpand={tabs?.guests}
                                    smallDevice={smallDevice}
                                />
                            </div>
                        </div>
                        <div className={s.applyButtonContainer}>
                            <Button
                                className={bt.btnPrimary}
                                onClick={this.handleApply}
                            >
                                <FormattedMessage {...messages.applyFilters} />
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

const mapState = state => ({
    filtersModal: state?.modalStatus?.isSimplifiedFiltersModal,
    userData: state?.account?.data,
    fieldsSettingsData: state?.listingFields?.data,
    personalized: state?.personalized
});

const mapDispatch = {
    closeSimplifiedFiltersModal,
    change,
    setPersonalizedValues,
    submitForm
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(SimplifiedFiltersModal)));
